export default __webpack_public_path__ + "static/bethany-67ecc1060a6bc0f550c60380aaa78436.jpg";